<app-page-header
  title="Home"
  titleLink="/bet-summary"
  active_item="Resumo de Apostas"
></app-page-header>

<form [formGroup]="filters">
  <div class="row">
    <h5>Resumo de Apostas</h5>

    <div class="col-md-12 col-xl-12">
      <div
        class="card sales-summary shadow"
        [ngClass]="{
          'rounded-10': !isFilterColapsed,
          'rounded-10-top': isFilterColapsed,
        }"
      >
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.filters" | translate }}</div>
          <div class="card-options">
            <a
              href="javascript:void(0)"
              class="card-options-collapse"
              data-bs-toggle="card-collapse"
              (click)="filterColapse()"
              [attr.aria-expanded]="!isFilterColapsed"
            >
              <i
                class="fe fe-chevron-{{ !isFilterColapsed ? 'up' : 'down' }}"
              ></i>
            </a>
          </div>
        </div>

        <div
          class="card-body filter-extrato"
          [(ngbCollapse)]="isFilterColapsed"
        >
          <div class="row">
            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">Data Inicial</label>
                <mat-form-field
                  appearance="fill"
                  class="w-100 date-align custom-datetime"
                >
                  <input
                    #startText
                    matInput
                    [matDatepicker]="pickerIni"
                    placeholder="DD/MM/YYYY"
                    [formControl]="filters.controls.initialDate"
                    (input)="startRaw = startText.value"
                    (dateChange)="onDateChange('initialDate', startText.value)"
                    (blur)="parseDateInput('initialDate', startRaw)"
                    (keydown.enter)="parseDateInput('initialDate', startRaw)"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerIni"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerIni startView="month"></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">Data Final</label>
                <mat-form-field
                  appearance="fill"
                  class="w-100 date-align custom-datetime"
                >
                  <input
                    #endText
                    matInput
                    [matDatepicker]="pickerFim"
                    placeholder="DD/MM/YYYY"
                    [formControl]="filters.controls.endDate"
                    (input)="endRaw = endText.value"
                    (dateChange)="onDateChange('endDate', endText.value)"
                    (blur)="parseDateInput('endDate', endRaw)"
                    (keydown.enter)="parseDateInput('endDate', endRaw)"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerFim"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerFim startView="month"></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">Tipo de Busca</label>
                <ng-select
                  [items]="filterTypeOptions"
                  bindLabel="label"
                  bindValue="value"
                  [clearable]="false"
                  [searchable]="false"
                  [formControl]="filters.controls.filterType"
                >
                </ng-select>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtSearchValue" class="form-label">Busca</label>
                <div class="input-icon-container">
                  <input
                    class="form-control"
                    type="text"
                    id="txtSearchValue"
                    [formControl]="filters.controls.searchValue"
                    [placeholder]="getSearchPlaceholder()"
                  />
                  <i
                    class="fe fe-clipboard input-icon btn-color"
                    (click)="pasteSearchValue()"
                  ></i>
                </div>
              </div>
            </div>

            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="buscar(startRaw, endRaw)"
              >
                <i class="fe fe-search me-2"></i
                >{{ "common.searchButton" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading-extrato" *ngIf="!isLoaded">
      <div class="dimmer active">
        <div class="lds-ring">
          <div></div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xl-12">
      <div class="card rounded-10 shadow">
        <div class="row">
          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-warning-transparent text-warning me-3"
                >
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">
                    Total Aposta
                  </span>
                  <p class="fs-15 me-3 mb-0">{{ totalBet | formatCurrency }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-danger-transparent text-danger me-3"
                >
                  <i class="fa fa-caret-down"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">
                    Total Perdas
                  </span>
                  <p class="fs-15 me-3 mb-0">
                    {{ totalLoss | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <span
                  class="avatar avatar-md rounded-3 bg-success-transparent text-success me-3"
                >
                  <i class="fa fa-caret-up"></i>
                </span>
                <div class="me-2">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">
                    Total Prêmios
                  </span>
                  <p class="fs-15 me-3 mb-0">
                    {{ totalAwards | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <a href="javascript:void(0)">
                  <span
                    class="avatar avatar-md rounded-3 bg-primary-transparent text-danger me-3"
                  >
                    <i class="fa fa-caret-up icon-blue"></i>
                  </span>
                </a>
                <div class="me-2">
                  <a href="javascript:void(0)">
                    <span class="mb-1 fs-13 font-weight-500 text-muted me-3">
                      RTP
                    </span>
                  </a>
                  <p class="fs-15 me-3 mb-0">{{ rtp | number: "1.2-2" }}%</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <a href="javascript:void(0)">
                  <span
                    class="avatar avatar-md rounded-3 bg-primary-transparent text-danger me-3"
                  >
                    <i class="fa fa-caret-up icon-blue"></i>
                  </span>
                </a>
                <div class="me-2">
                  <a href="javascript:void(0)">
                    <span class="mb-1 fs-13 font-weight-500 text-muted me-3">
                      GGR Gerado
                    </span>
                  </a>
                  <p class="fs-15 me-3 mb-0">
                    {{ balanceGGR | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xl col-lg-6 col-sm-6 px-0">
            <div class="card-body text-center">
              <div class="d-flex">
                <a href="javascript:void(0)">
                  <span
                    class="avatar avatar-md rounded-3 bg-primary-transparent text-danger me-3"
                  >
                    <i class="fa fa-caret-up icon-blue"></i>
                  </span>
                </a>
                <div class="me-2">
                  <a href="javascript:void(0)">
                    <span class="mb-1 fs-13 font-weight-500 text-muted me-3">
                      GGR Devido
                    </span>
                  </a>
                  <p class="fs-15 me-3 mb-0">
                    {{ debtorGGR | formatCurrency }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card sales-summary rounded-10 shadow">
        <div class="card-header">
          <div class="card-title mb-0">Resumo de Apostas</div>
          <div class="card-options">
            <button type="button" class="btn btn-pill btn-default-light">
              <i class="fe fe-download me-2"></i>Exportar Excel
            </button>
            <button
              type="button"
              class="btn btn-pill btn-default-light"
              (click)="downloadPdf()"
            >
              <i class="fe fe-download me-2"></i>Exportar PDF
            </button>
          </div>
        </div>
        <div class="card-body button-table">
          <app-table-bet-summary
            (rowsLoaded)="onRowsLoaded()"
            (loadError)="onTableLoadError()"
          ></app-table-bet-summary>
        </div>
      </div>
    </div>
  </div>
</form>
